import { useLocation, Link } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <div className="relative z-10">
        <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center rounded-full bg-background-100 border border-background-200/50">
          <i className="ri-error-warning-line text-foreground-500 text-2xl"></i>
        </div>
        <h1 className="text-7xl md:text-9xl font-black text-foreground-200 font-heading mb-4">
          404
        </h1>
        <h2 className="text-xl md:text-2xl font-semibold text-foreground-100 mb-3">
          页面不存在
        </h2>
        <p className="text-sm text-foreground-500 font-mono mb-2">
          {location.pathname}
        </p>
        <p className="text-sm md:text-base text-foreground-400 mb-8">
          您访问的页面可能已被移除，或者链接地址有误。
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-950 font-semibold rounded-full text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-home-line"></i>
          </div>
          返回首页
        </Link>
      </div>
    </div>
  );
}